import { Component, inject, Input, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '@core/services/auth.service';
import { Store } from '@ngrx/store';
import { AuthActions } from '@core/store/auth/auth.actions';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '@core/services/local-storage.service';
import { LOCAL_STORAGE_KEY_LANGUAGE, LOCAL_STORAGE_KEY_USER_NAME } from '@core/constant/constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, TranslateModule, CommonModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit, OnDestroy {
  isExpandedToolbar: boolean = false;
  userName: string = '';
  currentDate: string = '';
  currentTime: string = '';
  private timeInterval: any;
  private languageSubscription?: Subscription;

  @Input() changeShowSlidebar: () => void = () => {};
  constructor(
    private store: Store,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private localStorageService: LocalStorageService
  ) {}
  logout = () => {
    this.store.dispatch(AuthActions.logout());
    this.authService.logout();
    this.router.navigate(['/login']);
  };

  ngOnInit(): void {
    // Load the saved language from local storage
    const savedLanguage = this.localStorageService.getData(LOCAL_STORAGE_KEY_LANGUAGE);
    if (savedLanguage) {
      this.translate.use(savedLanguage);
    }
    this.userName = this.localStorageService.getData(LOCAL_STORAGE_KEY_USER_NAME) || '';
    
    this.updateDateTime();
    this.timeInterval = setInterval(() => {
      this.updateDateTime();
    }, 1000);

    this.languageSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateDateTime();
    });
  }

  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  updateDateTime(): void {
    const now = new Date();
    
    if (this.translate.currentLang === 'al') {
      const albanianMonths = [
        'janar', 'shkurt', 'mars', 'prill', 'maj', 'qershor',
        'korrik', 'gusht', 'shtator', 'tetor', 'nëntor', 'dhjetor'
      ];
      const monthName = albanianMonths[now.getMonth()];
      this.currentDate = `${now.getDate()} ${monthName} ${now.getFullYear()}`;
    } else {
      const dateOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      this.currentDate = now.toLocaleDateString('en-US', dateOptions);
    }
    
    const locale = this.translate.currentLang === 'al' ? 'sq-AL' : 'en-US';
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    this.currentTime = now.toLocaleTimeString(locale, timeOptions);
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    this.localStorageService.saveData(LOCAL_STORAGE_KEY_LANGUAGE, language);
    this.updateDateTime();
  }

  // changePassword() {
  //   this.router.navigate(['/change-password']);
  // }

  toggleToolbar() {
    this.isExpandedToolbar = !this.isExpandedToolbar;
  }
}
